// @ts-nocheck
class WIvideoPaly extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {

        this.videoInterSection();
  
    }
    // Video play
    videoPlay() {
        let videoUrl = this.querySelector('video').getAttribute('data-videourl');
        let videoSource = this.querySelector('.WI_videoSource');
        let videoThumbnail = this.querySelector('img');
        videoSource.src = videoUrl;
        this.querySelector('video').load();
        this.querySelector('video').play();
          
    }
    // Video intersection
    videoInterSection() {
        let observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.videoPlay();
                    observer.unobserve(this);
                }
            });
        },{
            rootMargin: "10px", // Load earlier (you can adjust this)
        });
        observer.observe(this);
    }
}

customElements.define('wi-videoplay', WIvideoPaly);